<template lang="pug">
div(:style="tabStyle")
  img(
    src="https://sisep.minedu.gob.bo/img/logo-minedu-2025-horizontal.jpg",
    width="159px",
    style="display: inline; float: left; margin-right: 20px; padding: 0px 0px 0px 0px; cursor: pointer;margin-left:5px;",
    @click="toHome()",
    v-show="showLogo"
  )
  //-v-btn(v-if="$store.state.loadingTabs" color="blue darken-4" fab text dark loading style="padding:0px;margin:0px;")
  v-btn(
    v-if="$store.state.loadingTabs",
    color="#960407",
    fab,
    icon,
    text,
    dark,
    loading,
    style="padding: 0px !important; margin: 0px; margin-left: -20px; margin-top: 11px; float: left; diplay: inline"
  )
  v-tabs(
    height="70",
    color="#960407",
    slider-size=4,
    v-model="currentTab",
    show-arrows,
    v-if="!$store.state.loadingTabs"
  )
    //-v-tab(@click="callback('/home')" v-if="$can(['rol.sich'])") Inicio.
    //-v-tab(@click="callback('/home')" v-else) Inicio
    v-tab(@click="callback('/home')", v-show="false") Invisible
    v-tab(@click="callback('/home')") Inicio
    //TODO: FOR VIEW
    //-v-tab.txtn(@click="callback('/ui/ui-distrito/lista-mis-memorandums-de-designacion')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])") Permuta
    //-v-tab(@click="callback('/ui/ui-ascenso')",v-if="!$can(['manager.menu.cns'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Ascenso<br>De Categoría 2026
    v-tab(@click="callback('/ui/ui-ficha-calificaciones')" v-if="$store.state.persona && $store.state.persona.idUsuario > 0")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Ficha Calificación de Demérito<br>Y Hoja de Concepto
    v-tab(@click="callback('/ui/ui-bases-certificaciones')",v-if="$can(['app.bases.menu_portal'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Bases<br>SEP
    //-   v-tab(@click="callback('/ui/ui-institucionalizacion')")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Inscripción Institucionalización<br>2024 - 2026
    //-v-tab(@click="callback('/ui/ui-institucionalizacion')", v-if="$can(['rol.institucionalizacion.auditoria.interna'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Inscripción Institucionalización<br>2024 - 2026
    v-tab(
      @click="callback('/ui/ui-distrito')",
      v-if="$can(['menu.tecnicoDepartamento', 'menu.administrador', 'menu.directorUnidadEducativa', 'menu.tecnicoDistrito', 'menu.tecnicoUgpsep', 'manager.menu.abms'])"
    )
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") ABMS
    v-tab(@click="callback('/ui/ui-subsidio')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Proceso<br>Planillas
    //-TEMPv-menu(offset-y transition="slide-y-transition" auto)
      template(v-slot:activator="{ on }")
          v-tab(v-on="on")
              v-layout
                  v-flex(xs12).text-center
                      h4.pb-2.txtn Maestros
                      v-icon(style="position:absolute;bottom:0px;left:46%") fas fa-angle-down
      v-list
          v-list-item(@click="callback('/ui/ui-distrito/lista-mis-memorandums-de-designacion')") Mis items
          //-v-list-item(@click="callback('/ui/ui-distrito/inscripcion-a-compulsa')") Compulsas nacionales
    v-tab(@click="callback('/ui/ui-distrito/inscripcion-a-compulsa')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Compulsas<br>Nacionales
    v-tab(@click="callback('/ui/ui-bases-certificaciones/subsidio-zona')", v-if="!$can(['manager.menu.cns','manager.menu.despacho'])" )
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Subsidio<br>de Zona
    v-tab(@click="callback('/ui/ui-rotulo')", v-if="$can(['rotulo.menu.portal'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Rotulos<br>Observados
    v-tab(@click="callback('/ui/ui-maestros-sin-cargo')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Registro de Maestros<br>Sin Cargo
    //- added this 2020
    //-2021-28-10       v-tab(@click="callback('/ui/ui-distrito/inscripcion-a-compulsa')")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Compulsas<br>Nacionales

    //-CHANGEIVANv-tab(@click="callback('/ui/ui-requerimiento-items')",v-if="$can(['rol.td_abms_req'])")
    //-v-tab(@click="callback('/ui/ui-asignacion-items')",v-if="$can(['manager.menu.requerimiento'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") ITNC 2026
          //-h4.txtn(style="line-height: 20px") Requerimiento<br>ITNC 2022
    v-tab(@click="callback('/ui/ui-sich')", v-if="$can(['rol.sich'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") SICH
    //TODO: FOR VIEW
    //-- BLANK v-tab(@click="callback('/ui/ui-seguimiento')", v-if="$can(['app.seguimiento'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") SEGUIMIENTO
    //-DNT-disable  v-tab(@click="callback('/ui/ui-bases')",v-if="$can(['app.bases.menu_portal'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Bases<br>SEP
    v-tab(@click="callback('/ui/ui-form-rotulo-observado/')", v-if="$can(['rol.rotulo'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Solicitud de<br>Rotulo Observado
    //-v-tab(@click="callback('https://wikipedia.com')" v-if="$can(['app.bases.menu_portal'])")
      v-layout
          v-flex(xs12).text-center
              h4.txtn(style="line-height:20px;") WIKI
    //-v-tab(@click="callback('/ui/ui-rda/home')")
      v-layout
          v-flex(xs12).text-center
              h4.txtn(style="line-height:20px;") RDA
    //-v-tab(
      @click="callback('/ui/ui-asignacion-items')"
      v-if="$can(['rol.td_abms_req'])"
      ) Requerimiento<br>2023
    v-tab(@click="callback('/ui/ui-requerimiento-items')",v-if="$can(['manager.menu.requerimiento'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Requerimiento<br>ITNC 2027
    //-TEMPv-tab(@click="callback('/ui/ui-bases')" v-if="$can(['rol.tecnico_ugpsep_sistema_reportes'])")
      v-layout
          v-flex(xs12).text-center
              h4.txtn(style="line-height:20px;") Credenciales
    v-tab(
      @click="callback('/ui/ui-bases-cns')",
      v-if="$can(['manager.menu.cns'])"
    )
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Boleta<br>SEP-CNS
    v-tab(@click="callback('/ui/ui-suplencias')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Suplencias
    //-Reemplazado por tab: proceso-planillas  v-tab(@click="callback('/ui/ui-subsidio')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Subsidio
    //-Reemplazado por tab: proceso-planillas  v-tab(@click="callback('/ui/ui-subsidio')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Registro<br>de discapacidad
    //-Reemplazado por tab: proceso-planillas  v-tab(@click="callback('/ui/ui-subsidio')",v-if="!$can(['manager.menu.cns','manager.menu.despacho'])")
      v-layout
        v-flex.text-center(xs12)
          h4.txtn(style="line-height: 20px") Reversión<br>de Boletas
</template>

<style>
.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none !important;
}
</style>

<script>
export default {
  data: function () {
    return {
      currentTab: 0,
    };
  },
  props: {
    callback: Function,
    /*currentTab: {
            type: Number,
            default: 0
        }*/
  },
  computed: {
    showLogo() {
      if (this.$store.state.windowSize.w > 550) {
        return true;
      } else {
        return false;
      }
    },
    tabStyle() {
      if (this.$store.state.windowSize.w > 1100) {
        var hh = this.$store.state.windowSize.w - 500;
        return "height:70px;width:" + hh + "px;";
      }
      if (this.$store.state.windowSize.w > 800) {
        var hh = this.$store.state.windowSize.w - 270 - 100;
        return "height:70px;width:" + hh + "px;";
      } else if (this.$store.state.windowSize.w > 550) {
        var hh = this.$store.state.windowSize.w - 270 + 100;
        return "height:70px;width:" + hh + "px;";
      } else {
        var hh = this.$store.state.windowSize.w - 150;
        return "height:70px;width:" + hh + "px;";
      }
    },
  },
  methods: {
    toHome() {
      this.$store.state.tabDocument = false;
      this.currentTab = 1;
      this.callback("/home");
    },
    showInvisible() {
      this.currentTab = 0;
    },
  },
  created() {
    this.currentTab = 1;
    /*console.log('created CustomTabs .vue')*/
    /*console.log(this.$can(['app.bases.menu_portal']))
        setTimeout(function(){
            console.log('settimeout', this.$can(['app.bases.menu_portal']))
        }.bind(this),5000);*/
  },
};
</script>
